<!-- Header -->
<div class="row text-center fw-semibold border-bottom pb-2">
  <div class="col"></div>
  <div class="col">Psychiatrist</div>
  <div class="col">Psychologist</div>
  <div class="col">Counsellor</div>
</div>

<!-- Session Allot -->
<div class="row text-center align-items-center mt-2 border-bottom">
  <div class="col text-start fw-medium">Session Assigned</div>
  <div class="col">
    <div>
      {{ practitionerSessionData.assignedPsychiatristSession }}/{{
        practitionerSessionData.totalPsychiatristSession
      }}
    </div>
    <div class="text-success fs-5">
      <i
        [class]="
          practitionerSessionData.assignedPsychiatristSession >=
          practitionerSessionData.totalPsychiatristSession || isAssignEmoneeds(rppAssignedList, 15, [159, 280])
            ? 'pi pi-check-circle'
            : 'pi pi-times-circle'
        "
      ></i>
    </div>
  </div>
  <div class="col">
    <div>
      {{ practitionerSessionData.assignedPsychologistSession }}/{{
        practitionerSessionData.totalPsychologistSession
      }}
    </div>
    <div class="text-danger fs-5">
      <i
        [class]="
          practitionerSessionData.assignedPsychologistSession >=
          practitionerSessionData.totalPsychologistSession || isAssignEmoneeds(rppAssignedList, 13, [161, 296])
            ? 'pi pi-check-circle'
            : 'pi pi-times-circle'
        "
      ></i>
    </div>
  </div>
  <div class="col">
    <div>
      {{ practitionerSessionData.assignedCounsellorSession }}/{{
        practitionerSessionData.totalCounsellorSession
      }}
    </div>
    <div class="text-danger fs-5">
      <i
        [class]="
          practitionerSessionData.assignedCounsellorSession >=
          practitionerSessionData.totalCounsellorSession || isAssignEmoneeds(rppAssignedList, 16, [160, 293])
            ? 'pi pi-check-circle'
            : 'pi pi-times-circle'
        "
      ></i>
    </div>
  </div>
</div>

<!-- Case History -->
<div class="row text-center align-items-center mt-3 border-bottom">
  <div class="col text-start fw-medium">Case History</div>
  <div class="col"></div>
  <div class="col">
    <div class="text-danger fs-5">
      <span
        [class]="
          patientInductionDetails?.isCheifComplaintFilled
            ? 'filled-color'
            : 'not-filled-color'
        "
      >
        {{
          patientInductionDetails?.isCheifComplaintFilled
            ? "Filled"
            : "Not-Filled"
        }}
      </span>
      <i
        [class]="
          patientInductionDetails?.isCheifComplaintFilled
            ? 'pi pi-check-circle'
            : 'pi pi-times-circle'
        "
      ></i>
    </div>
    <div
      [class]="
        patientInductionDetails?.isCheifComplaintFilled
          ? 'filled-color'
          : 'not-filled-color'
      "
    >
      <span
        >Fields -
        {{ patientInductionDetails?.caseHistoryData?.filledCount || 0 }}/{{
          patientInductionDetails?.caseHistoryData?.totalFields || 0
        }}</span
      >
    </div>
  </div>
  <div class="col"></div>
</div>

<!-- Treatment Plan -->
<div class="row text-center align-items-center mt-3 border-bottom">
  <div class="col text-start fw-medium">Treatment Plan</div>
  <div class="col"></div>
  <div class="col">
    <div class="fs-5">
      <span
        [class]="
          isTreatmentPlanFilled(patientInductionDetails)
            ? 'filled-color'
            : 'not-filled-color'
        "
      >
        ({{
          patientInductionDetails?.provisionalDiagnosisData?.treatment_plan
            ?.length || 0
        }})
        {{
          isTreatmentPlanFilled(patientInductionDetails)
            ? "Concern"
            : "Concerns"
        }}
      </span>
      <i
        [class]="
          isTreatmentPlanFilled(patientInductionDetails)
            ? 'pi pi-check-circle'
            : 'pi pi-times-circle'
        "
      >
      </i>
    </div>
  </div>
  <div class="col"></div>
</div>

<!-- Diagnosis -->
<div class="row text-center align-items-center mt-3 border-bottom">
  <div class="col text-start fw-medium">Diagnosis</div>
  <div class="col"></div>
  <div class="col">
    <div class="text-danger fs-5">
      <span
        [class]="
          isProvisionalDiagnosisFilled(patientInductionDetails)
            ? 'filled-color'
            : 'not-filled-color'
        "
      >
        {{
          isProvisionalDiagnosisFilled(patientInductionDetails)
            ? "Filled"
            : "Not-Filled"
        }}
      </span>
      <i
        [class]="
          isProvisionalDiagnosisFilled(patientInductionDetails)
            ? 'pi pi-check-circle'
            : 'pi pi-times-circle'
        "
      >
      </i>
    </div>
  </div>
  <div class="col"></div>
</div>

<!-- Induction with -->
<form [formGroup]="inductionPersonForm" class="row align-items-center mt-3">
  <div class="col-3 fw-medium">Induction with</div>
  <div class="col">
    <div class="d-flex flex-wrap gap-2">
      <p-dropdown
        [options]="psychiatristList"
        filter="true"
        [autoDisplayFirst]="false"
        placeholder="Select Psychiatrist"
        formControlName="psychiatristId"
        appendTo="body"
        panelStyleClass="dropdown-up"
      >
      </p-dropdown>
      <p-dropdown
        [options]="psychologistList"
        filter="true"
        [autoDisplayFirst]="false"
        placeholder="Select Psychologist"
        formControlName="psychologistId"
        appendTo="body"
        panelStyleClass="dropdown-up"
      >
      </p-dropdown>
      <p-dropdown
        [options]="counsellorList"
        filter="true"
        [autoDisplayFirst]="false"
        placeholder="Select Counsellor"
        formControlName="counsellorId"
        appendTo="body"
        panelStyleClass="dropdown-up"
      >
      </p-dropdown>
      <p-dropdown
        [options]="marketingList"
        filter="true"
        [autoDisplayFirst]="false"
        placeholder="Select Marketing"
        formControlName="marketingId"
        appendTo="body"
        panelStyleClass="dropdown-up"
      >
      </p-dropdown>
    </div>
  </div>
  <div
    class="d-grid mt-3"
    *ngIf="
      isProvisionalDiagnosisFilled(patientInductionDetails) &&
      isTreatmentPlanFilled(patientInductionDetails) &&
      patientInductionDetails?.isCheifComplaintFilled &&
      (practitionerSessionData.assignedPsychiatristSession >=
        practitionerSessionData.totalPsychiatristSession || isAssignEmoneeds(rppAssignedList, 15, [159, 280])) &&
      (practitionerSessionData.assignedPsychologistSession >=
        practitionerSessionData.totalPsychologistSession || isAssignEmoneeds(rppAssignedList, 13, [161, 296])) &&
      (practitionerSessionData.assignedCounsellorSession >=
        practitionerSessionData.totalCounsellorSession || isAssignEmoneeds(rppAssignedList, 16, [160, 293]))
    "
  >
    <button class="btn btn-secondary" (click)="handleInductionFormSubmit()">
      Induction Submit
    </button>
  </div>
</form>
